import { ActivatedRoute } from '@angular/router';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription, zip } from 'rxjs';
import { tap } from 'rxjs/operators';

import { BasePage } from '../../base.page';
import {
    ContractInterface,
    ContractSignatureType,
    DisinvestmentInterface,
    GetContractSignatoriesUseCase,
    GetContractUseCase,
    OrderClientInterface,
    SignDisinvestmentUseCase,
} from '../../../../core';
import { DisinvestmentPage } from '../disinvestment.page';
import { ErrorDialog } from '../../../ui/dialog/error/error.dialog';
import { Id } from '../../../domain/data';
import { LocalStorage } from '../../../client/helpers/local-storage';
import { ParentEvents } from '../../../utils/parent-events.service';

import { environment } from '../../../../../environments/environment';

@Component({
    templateUrl: './disinvestment-sign.page.html',
    styleUrls: ['./disinvestment-sign.page.scss'],
})
export class DisinvestmentSignPage extends BasePage implements AfterViewInit, OnDestroy, OnInit {
    private backSubscription: Subscription;

    public contract: ContractInterface;
    public changed = false;
    public disinvestment: DisinvestmentInterface;
    public participants: OrderClientInterface[] = [];
    public isClientPortal = environment.portalClient;

    constructor(
        disinvestmentPage: DisinvestmentPage,
        parentEvents: ParentEvents,
        private dialog: MatDialog,
        private getContractUseCase: GetContractUseCase,
        private getContractSignatoriesUseCase: GetContractSignatoriesUseCase,
        private localStorage: LocalStorage,
        private route: ActivatedRoute,
        private signDisinvestmentUseCase: SignDisinvestmentUseCase
    ) {
        super(parentEvents);
        disinvestmentPage.showBackButton();
        this.backSubscription = disinvestmentPage.back.subscribe(() => {
            window.history.back();
        });
    }

    get signedBy(): 'all' | 'one' {
        return (this.contract && this.contract.signatureType === ContractSignatureType.JOINT) || this.changed ? 'all' : 'one';
    }

    ngOnInit(): void {
        this.getDisinvestment();
    }

    private getDisinvestment(): void {
        this.route.data.subscribe((data) => {
            this.changed = data.changed || false;
            this.disinvestment = data.disinvestment;

            this.getSignatories();
        });
    }

    private getSignatories(): void {
        let signatoriesParams = {};
        if (!this.changed) {
            signatoriesParams = {
                clientCode: new Id(this.localStorage.clientCode),
            };
        }

        zip(
            this.getContractUseCase.bind().pipe(
                tap((transaction) =>
                    transaction.fold(
                        (contract) => (this.contract = contract),
                        (throwable) =>
                            this.dialog.open(ErrorDialog, {
                                data: { text: throwable.message },
                            })
                    )
                )
            ),
            this.getContractSignatoriesUseCase.bind(signatoriesParams).pipe(
                tap((transaction) =>
                    transaction.fold(
                        (signatories) => {
                            this.participants = signatories;
                            this.participants.forEach((participant) => (participant.signatureType = undefined));
                        },
                        () =>
                            this.dialog.open(ErrorDialog, {
                                data: { text: 'error.selected-product-not-signatories' },
                            })
                    )
                )
            )
        ).subscribe();
    }

    ngOnDestroy() {
        this.backSubscription.unsubscribe();
    }

    onSubmit() {
        this.signDisinvestmentUseCase
            .bind({
                signatories: this.participants.filter((participant) => !!participant.signatureType),
                disinvestment: this.disinvestment,
            })
            .subscribe((transaction) => {
                transaction.fold(
                    () => this.parentEvents.cancel(),
                    (throwable) =>
                        this.dialog.open(ErrorDialog, {
                            data: { text: throwable.message },
                        })
                );
            });
    }
}
